module.exports = __webpack_public_path__ + "img/code2.44e69c18.png";